import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withSnackbar } from "notistack"

import {
  clearNotificationCount,
  clearNotificationList,
  clearUnreadNotificationCount,
  deleteNotification,
  getNotificationList,
  getNotificationSmallList,
  updateNotificationList,
} from "../../../library/store/actions/creators/notificationCreators"
import Loader from "../../../components/ui/loader"
import NotificationCard from "./notificationCard"
import getErrorText from "../../../library/constants/errorTypes"
import withScroll from "../../../hocs/withScroll/withScroll"
import { LIMIT } from "../../../library/constants/limits"

class Notifications extends React.Component {
  state = {
    dataReceived: false,
  }

  async componentDidMount() {
    const {
      notifications: { notificationList },
    } = this.props
    try {
      await this.props.getNotificationList({ offset: notificationList.length })
      this.setState({
        dataReceived: true,
      })
      this.props.clearNotificationCount()
      this.props.clearUnreadNotificationCount()
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  componentWillUnmount() {
    this.props.clearNotificationList()
  }

  onScroll = async () => {
    if (!this.state.dataReceived) return
    this.setState({ dataReceived: false })
    const offset = this.props.notifications.notificationList.length
    try {
      await this.props.getNotificationList({ offset: offset, limit: LIMIT })
      this.setState({ dataReceived: true })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  render() {
    const {
      notifications: { notificationList, unreadCounter },
      deleteNotification,
      updateNotificationList,
      getNotificationSmallList,
    } = this.props
    const { dataReceived } = this.state
    return (
      <div className="common-page__content common-page__content--static">
        <main className="common-page__main">
          <div className="box__heading">Notifications</div>
          {notificationList.map((n, i) => {
            return (
              <NotificationCard
                key={n.id}
                notification={n}
                isRead={!(i + 1 <= unreadCounter)}
                deleteNotification={deleteNotification}
                updateNotifications={updateNotificationList}
                notificationsLength={notificationList.length}
                getNotificationSmallList={getNotificationSmallList}
              />
            )
          })}
          {!dataReceived && <Loader />}
        </main>
      </div>
    )
  }
}

const mapState = ({ notifications }) => ({ notifications })
const mapDispatch = (dispatch) =>
  bindActionCreators(
    {
      getNotificationList,
      clearNotificationList,
      updateNotificationList,
      clearNotificationCount,
      deleteNotification,
      getNotificationSmallList,
      clearUnreadNotificationCount,
    },
    dispatch
  )

export default connect(
  mapState,
  mapDispatch
)(withScroll(withSnackbar(Notifications)))
